import { state } from '../map_state/state'
import { callMethodOnKeydown, isTyping } from '../helpers'
import { Renderer } from '../renderer'

class DarkModeTool {
  constructor () {
    this.element = document.getElementById('mct-dark-mode')
    this.container = document.getElementById('mct-container')

    state.darkMode = document.body.classList.contains('dark-mode')

    this.bindEvents()
    this.syncUi()
  }

  bindEvents () {
    this.toggleDarkMode = this.toggleDarkMode.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)

    this.element.addEventListener('click', this.toggleDarkMode)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.toggleDarkMode)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 't') callMethodOnKeydown(e.target, this.toggleDarkMode)
  }

  syncUi () {
    this.element.classList.toggle('selected', state.darkMode)
    this.container.classList.toggle('dark', state.darkMode)
    Renderer.render()
  }

  toggleDarkMode () {
    state.darkMode = !state.darkMode
    this.syncUi()
  }
}

export let darkModeTool = null

export function initDarkModeTool () {
  darkModeTool = new DarkModeTool()
  return darkModeTool
}
